/* eslint-disable no-unused-vars */
import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch,
} from "react-hook-form";
import ReactSelect from "react-select";
import { selectStyles } from "../../../utils/selectStyel";
import AssignmentTypeComp from "../../EditModelbuilder/Rules Editing/AssignmentTypeComp";
import CaseProRulesType from "./CaseProcessRulesTypeBaseComp/CaseProdRulesType";
import CaseProIterationTypeComp from "./CaseProcessRulesTypeBaseComp/CaseProIterationTypeComp";
import CaseProRestType from "./CaseProcessRulesTypeBaseComp/CaseProRestType";
const typeOptions = [
  { value: "RULE", label: "RULE" },
  { value: "ITERATION", label: "ITERATION" },
  { value: "ASSIGNMENT", label: "ASSIGNMENT" },
  { value: "REST", label: "REST" },
];

export const CaseProRulesItem = ({
  control,
  path,
  remove,
  rule,
  depth = 0,
}) => {
  const { isOpen: condOpen, onToggle: toggleCond } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: trueOpen, onToggle: toggleTrue } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: falseOpen, onToggle: toggleFalse } = useDisclosure({
    defaultIsOpen: true,
  });
  const { setValue } = useFormContext();
  const type = useWatch({
    control,
    name: `${path}.TYPE`,
    defaultValue: rule?.TYPE ?? "RULE",
  });
  const leftBorderColor = depth === 0 ? "blue.400" : "gray.300";

  const {
    fields: trueSteps,
    append: addTrueStep,
    remove: removeTrueStep,
  } = useFieldArray({ control, name: `${path}.TRUE_STEP` });
  const {
    fields: falseSteps,
    append: addFalseStep,
    remove: removeFalseStep,
  } = useFieldArray({ control, name: `${path}.FALSE_STEP` });

  const resetFieldsForType = (newType) => {
    // Clear ALL unrelated fields
    const all = [
      "CONDITION",
      "TRUE_STEP",
      "FALSE_STEP",
      "FIELD",
      "VALUE",
      "URL",
      "PROCESSOR",
      "BODY",
      "HEADERS",
      "URL_PARAMS",
    ];
    all.forEach((f) =>
      setValue(`${path}.${f}`, undefined, { shouldDirty: true })
    );

    // Now set defaults for the chosen type
    if (newType === "RULE") {
      setValue(
        `${path}.CONDITION`,
        { Field: "", Operator: "==", Value: "" },
        { shouldDirty: true }
      );
      setValue(`${path}.TRUE_STEP`, [], { shouldDirty: true });
      setValue(`${path}.FALSE_STEP`, [], { shouldDirty: true });
    }

    if (newType === "ASSIGNMENT") {
      setValue(`${path}.FIELD`, "", { shouldDirty: true });
      setValue(`${path}.VALUE`, "", { shouldDirty: true });
    }

    if (newType === "REST") {
      setValue(`${path}.URL`, "", { shouldDirty: true });
      setValue(`${path}.PROCESSOR`, "", { shouldDirty: true });
      setValue(`${path}.BODY`, {}, { shouldDirty: true });
      setValue(`${path}.HEADERS`, [], { shouldDirty: true });
      setValue(`${path}.URL_PARAMS`, [], { shouldDirty: true });
    }
  };

  return (
    <Box
      bg="white"
      shadow="md"
      borderRadius="lg"
      p={4}
      mb={4}
      borderLeftWidth="5px"
      borderLeftColor={leftBorderColor}
      ml={`${depth * 6}px`}
      position="relative"
    >
      {/* Header */}
      <Stack direction="row" justify="space-between" align="center">
        <Heading size="sm" color="blue.600">
          Rule
        </Heading>
        <Button
          size="xs"
          leftIcon={<DeleteIcon />}
          colorScheme="red"
          variant="ghost"
          onClick={remove}
        >
          Delete
        </Button>
      </Stack>
      <Divider my={3} />

      {/* Type + ID */}
      <Stack direction={{ base: "column", md: "row" }} spacing={4}>
        <FormControl>
          <FormLabel>Type</FormLabel>
          <Controller
            control={control}
            name={`${path}.TYPE`}
            defaultValue="RULE"
            render={({ field: { onChange, value, ref } }) => (
              <ReactSelect
                inputRef={ref}
                value={typeOptions.find((o) => o.value === value)}
                onChange={(opt) => {
                  const newType = opt?.value;
                  onChange(newType);

                  // Reset fields based on new type
                  resetFieldsForType(newType);
                }}
                options={typeOptions}
                placeholder="Select type"
                styles={selectStyles}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <FormLabel>ID</FormLabel>
          <Controller
            control={control}
            name={`${path}.ID`}
            render={({ field }) => (
              <Input
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
                {...field}
              />
            )}
          />
        </FormControl>
      </Stack>

      <CaseProRulesType
        type={type}
        control={control}
        path={path}
        rule={rule}
        trueSteps={trueSteps}
        falseSteps={falseSteps}
        addTrueStep={addTrueStep}
        removeTrueStep={removeTrueStep}
        addFalseStep={addFalseStep}
        removeFalseStep={removeFalseStep}
      />

      {/* ASSIGNMENT */}
      {type === "ASSIGNMENT" && <AssignmentTypeComp path={path} />}

      {/* REST */}
      {type === "REST" && <CaseProRestType control={control} path={path} />}
      {type === "ITERATION" && (
        <CaseProIterationTypeComp
          control={control}
          // register={register}
          rule={rule}
          path={path}
          depth={depth}
        />
      )}
    </Box>
  );
};
